export default __webpack_public_path__ + "assets/90ea40d1f68ba61480e40818e37e0366.svg";